import { render } from "./treeMenu.vue?vue&type=template&id=e16fab98&scoped=true"
import script from "./treeMenu.vue?vue&type=script&lang=js"
export * from "./treeMenu.vue?vue&type=script&lang=js"

import "./treeMenu.vue?vue&type=style&index=0&id=e16fab98&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16fab98"]])

export default __exports__